const { formatText } = require('core/i18n').i18n;


/**
 * Reference:
 * 1 - Stocks - Acciones
 * 2 - Bonds - Bonos
 * 3 - Cash - Capital
 * 4 - Other - Otros
 * 99 - Unclassified - Sin clasificar
 **/
const assetAllocationType = type => {
    let text = '';

    switch (type) {
        case '1':
          text = formatText('fundsCard-stocks')
          break;
        case '2':
            text = formatText('fundsCard-bond')
          break;
        case '3':
            text = formatText('fundsCard-cash')
          break;
        case '4':
            text = formatText('fundsCard-others')
          break;
        default:
            text = formatText('fundsCard-unclassified')
      }

      return text
}


module.exports = assetAllocationType;
